import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './styles/brand.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// En producción, silenciar la salida de depuración de cualquier origen (código
// propio o librerías). Los errores siguen saliendo, ya sanitizados por utils/logger.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = console.info = console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppRoutes />
  </BrowserRouter>,
);